import mixpanelAdaptor from "@unibuddy/tracking/dist/adaptors/mixpanel";
import {useIdentifyUser} from "./useIdentifyUser";

export const IdentifyUser = () => {
    useIdentifyUser(mixpanelAdaptor);
    return null;
};
